import { render, staticRenderFns } from "./com-region.vue?vue&type=template&id=71817f94&scoped=true&"
import script from "./com-region.vue?vue&type=script&lang=js&"
export * from "./com-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71817f94",
  null
  
)

export default component.exports